import { render } from "./FeaturesDisplay.vue?vue&type=template&id=24bb15b4&scoped=true"
import script from "./FeaturesDisplay.vue?vue&type=script&lang=js"
export * from "./FeaturesDisplay.vue?vue&type=script&lang=js"

import "./FeaturesDisplay.vue?vue&type=style&index=0&id=24bb15b4&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=24bb15b4&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bb15b4"]])

export default __exports__